import { getConnectionInfo, getDeviceInfo } from "../../../infrastructure/storage/localStorage";

/**
 * Creates standardized metadata object for file operations
 * 
 * @param {Object} options - Optional metadata properties
 * @param {string} options.action - The file action ('edit', 'rename', 'delete')
 * @param {string} options.oldFileName - For rename operations, the original file name
 * @returns {Object} Metadata object with user and device information
 */
export const createOperationMetadata = (options = {}) => {
  const connInfo = getConnectionInfo();
  const deviceInfo = getDeviceInfo();
  
  return {
    lastEditTime: new Date().toISOString(),
    deviceName: deviceInfo.name ,
    deviceId: deviceInfo.guid,
    ...options
  };
};
